<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6WjIax/tc-custom/9781615952366.jpg?1718184631250" alt="This image is the cover for the book Strangers, Faye Longchamp Archaeological Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Strangers, Faye Longchamp Archaeological Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"This contemporary mystery is drenched with Florida history and with gothic elements that should appeal to a broad range of readers." —<i>Booklist</i></b></p><p>Faye Longchamp and husband Joe Wolf Mantooth have founded an archaeological consulting firm—just in time for the economy to tank. But a meeting with a couple who run an elegant B&amp;B in a historic home in St. Augustine, Florida, lands the firm's first big project. Within a day of their arrival at Dunkirk Manor, a lovely young employee disappears, leaving behind a sinister smear of blood in her car, a collection of priceless artifacts, and a note asking for Faye's help. Two days later, the missing woman's boyfriend is found floating in the Matanzas River, his throat slashed. The detective in charge of the case believes that the artifacts are key to the crime and hires Faye to track down their origin.</p><p>The artifacts Faye and Joe excavate at their work site date from every era of St. Augustine history, and the discovery of a buried cache of children's toys from the 1920s hits eight-months-pregnant Faye particularly hard. Dunkirk Manor seems haunted in a way that Faye can't explain.</p><p>Then a stunning discovery is made: the diary of a priest who left Spain in 1565 and was present at the city's birth. Faye is driven to translate the manuscript. In what could be an unfolding tale by the Brothers Grimm, Faye and Joe uncover some terrible secrets....</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Anna Evans
      </h2>
      
      <p class="authorDescription body article"><P>Mary Anna Evans is the author of the Faye Longchamp archaeological mysteries, which have received recognition including the Benjamin Franklin Award, the Mississippi Author Award, and three Florida Book Awards bronze medals. She is an assistant professor at the University of Oklahoma, where she teaches fiction and nonfiction writing. Winner of the 2018 Sisters in Crime (SinC) Academic Research Grant</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bb30536c